module.exports = __webpack_public_path__ + "static/media/analysis-and-report.b5da7fc2.svg";